import { pdfjs } from 'react-pdf';
const pdfjsBaseUrl = `//unpkg.com/pdfjs-dist@${pdfjs.version}`;
pdfjs.GlobalWorkerOptions.workerSrc = `${pdfjsBaseUrl}/build/pdf.worker.min.mjs`;
const sourceForPdfJs = async (source) => {
    if (typeof source === 'string') {
        return source;
    }
    if (typeof File !== 'undefined' && source instanceof File) {
        return { data: await source.arrayBuffer() };
    }
    return { data: source };
};
/** Page count and scale-1 boxes for a PDF, keyed by 1-based page index. */
export const readPdfPageMetrics = async (source) => {
    const loadingTask = pdfjs.getDocument(await sourceForPdfJs(source));
    const pdf = await loadingTask.promise;
    const sizes = new Map();
    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
        const page = await pdf.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 1 });
        sizes.set(pageNumber, { width: viewport.width, height: viewport.height });
    }
    return { pageCount: pdf.numPages, sizes };
};
